import React, { type FC } from 'react';
import { BackCrumb } from './SubComponents/BackCrumb';
import css from './TemplatePage.scss';
import { TemplateMainCard } from './SubComponents/TemplateMainCard';
import { Instructions } from './SubComponents/Instructions';
import { RelatedTemplates } from './SubComponents/RelatedTemplates';
import { HowToBuild } from './SubComponents/HowToBuild';
import { StickyHeader } from './SubComponents/StickyHeader';
import { AppLoader } from '../App/AppLoader';
import { DataHooks } from '../../constants/dataHooks';
import { useTemplatesData } from '../../hooks/useTemplatesData';

export const TemplatePage: FC = () => {
  const upperPartRef = React.useRef<HTMLDivElement>(null);
  const { currentTemplate: template } = useTemplatesData();

  if (!template) {
    return <AppLoader />;
  }

  return (
    <>
      <div
        data-hook={DataHooks.TemplatePage}
        className={css.templatePageWrapper}
      >
        <StickyHeader upperPartRef={upperPartRef} />
        <div className={css.templatePageLayout}>
          <div className={css.upperPartWrapper} ref={upperPartRef}>
            <BackCrumb />
            <TemplateMainCard />
          </div>
          <Instructions />
          <HowToBuild />
          <RelatedTemplates />
        </div>
      </div>
    </>
  );
};
